/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

import { useAuthContext } from "../../../hooks/useAuthContext";
import { jwtDecode } from "jwt-decode";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

const Basic = () => {
  const { dispatch } = useAuthContext();

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    setIsValid(email && password);
  }, [email, password])


  const handleSubmit = async (e) => {
      try{
          const response = await fetch(process.env.REACT_APP_URL_BASE + '/auth/login', {
            method: 'POST',
            headers: {
              'Accept': 'application/json', 
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                password: password
            })

          })
            
            const data = await response.json()

          if (response.status === 200) {
            localStorage.setItem("user", JSON.stringify(data));

            const user = {
                ...jwtDecode(data.token.toString()),
                token: data.token
            }


            dispatch({ type: "LOGIN", payload: user }); 
          } else {
            alert(data.message)
          }
      } catch (error) {
        console.log(error)
      }
  }

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="error"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
          <br />
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput type="text" label="Email" fullWidth onChange={(e) => setEmail(e.target.value)} />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" label="Password" fullWidth onChange={(e) => setPassword(e.target.value)}/>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth disabled={!isValid} onClick={handleSubmit}>
                sign in
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
